import { Flex, useToken } from '@chakra-ui/react';
import type { ToggleButtonsRef } from '@time-line/components/common';
import { ToggleButtons } from '@time-line/components/common';
import { useAnalytics } from 'hooks/useAnalytics';
import { useIsCalloutVisible } from 'hooks/useIsCalloutVisible';
import { useIsSkincare } from 'hooks/useIsSkincare';
import { HOME, SKINCARE_HOME } from 'lib/constants/routes';
import router from 'next/router';
import { useEffect, useRef, useState } from 'react';

import { Callout } from './Callout';
import { RESPONSIVE_BP } from './constants';

export const SiteToggle = () => {
  const isSkincare = useIsSkincare();
  const { analytics } = useAnalytics();
  const isCalloutVisible = useIsCalloutVisible();
  const [isCalloutClosed, setIsCalloutClosed] = useState(true);
  const toggleButtonsRef = useRef<ToggleButtonsRef>(null);
  const skincareRef = useRef<HTMLButtonElement>(null);
  const [selected, setSelected] = useState<string>(
    isSkincare ? 'skincare' : 'supplements',
  );

  const options = [
    {
      label: 'Supplements',
      value: 'supplements',
      onClick: () => {
        analytics.siteToggleSupplementsClick();
        router.push(HOME);
      },
    },
    {
      label: 'Skincare',
      value: 'skincare',
      onClick: () => {
        analytics.siteToggleSkincareClick();
        router.push(SKINCARE_HOME);
      },
    },
  ];

  useEffect(() => {
    setIsCalloutClosed(!isCalloutVisible);
  }, [isCalloutVisible]);

  useEffect(() => {
    setSelected(isSkincare ? 'skincare' : 'supplements');
  }, [isSkincare]);

  useEffect(() => {
    if (toggleButtonsRef.current) {
      const skincareButtonRef = toggleButtonsRef.current.getButtonRef(1);
      if (skincareButtonRef) {
        skincareRef.current = skincareButtonRef;
      }
    }
  }, []);

  const spacing = useToken('space', '5xs');

  return (
    <>
      <Flex
        gridColumn={{ base: '1 / -1', [RESPONSIVE_BP]: 'auto' }}
        justifySelf={{ base: 'center', [RESPONSIVE_BP]: 'start' }}
        width={{
          base: `calc(100% - ${spacing} - ${spacing})`,
          [RESPONSIVE_BP]: 'auto',
        }}
      >
        <ToggleButtons
          ref={toggleButtonsRef}
          ariaLabel="Choose a store"
          options={options}
          selected={selected}
          setSelected={setSelected}
          templateColumns={{
            base: 'repeat(2, minmax(0, 1fr))',
            [RESPONSIVE_BP]: 'repeat(2, auto)',
          }}
        />
      </Flex>
      {isCalloutVisible && !isCalloutClosed && (
        <Callout
          targetRef={skincareRef}
          verticalOffset={-parseInt(spacing) / 2}
          onCalloutClose={() => setIsCalloutClosed(true)}
        />
      )}
    </>
  );
};
